export default __webpack_public_path__ + "static/media/cpr-verification.38191cd1.png";